// extracted by mini-css-extract-plugin
export default {"wrapper":"deliveryInfo_wrapper__JQyUW","container":"deliveryInfo_container__WNx0-","head":"deliveryInfo_head__p+i0e","list":"deliveryInfo_list__ipoXi"};